export default __webpack_public_path__ + "static/topimage-70779d4eaebd1f377edb482cf8fd82a1.png";